import type { PostgrestError } from "@supabase/supabase-js";

/**
 * PostgREST often puts the useful text in `details` / `hint`, not only `message`.
 */
export function postgrestErrorText(err: PostgrestError | null | undefined): string {
  if (!err) return "";
  const e = err as PostgrestError & { details?: string; hint?: string };
  return [e.message, e.details, e.hint, e.code].filter(Boolean).join(" ");
}

/**
 * True when filtering on `deleted_at` failed because the column is missing (migration not applied).
 */
export function isMissingDeletedAtColumnError(err: PostgrestError | null | undefined): boolean {
  const t = postgrestErrorText(err);
  if (!t) return false;
  if (/\b42703\b/.test(t) && /\bdeleted_at\b/i.test(t)) return true;
  if (/\bdeleted_at\b/i.test(t) && /does not exist|undefined column/i.test(t)) return true;
  return false;
}
